import { render } from "./LoginRegisterNew.vue?vue&type=template&id=0a0c7318&scoped=true"
import script from "./LoginRegisterNew.vue?vue&type=script&lang=ts"
export * from "./LoginRegisterNew.vue?vue&type=script&lang=ts"

import "./LoginRegisterNew.vue?vue&type=style&index=0&id=0a0c7318&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a0c7318"

export default script